
// src/components/LandingPage.jsx
import React, { useState } from 'react';
import CommonHeader from './CommonHeader';
import CommonFooter from './CommonFooter';
import SignupForm from './SignupForm';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import CookiePolicy from './CookiePolicy';
import ContactUs from './ContactUs';
import './LegalPages.css';
import './LandingPage.css';
import config from '../config';

const LandingPage = ({ onGetStarted, onLogin, onBlogClick }) => {
  const costPerPdf = parseFloat(config.COST_PER_PDF)
  const [showSignup, setShowSignup] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showCookiePolicy, setShowCookiePolicy] = useState(false);
  const [showContact, setShowContact] = useState(false);

  const handleSwitchToLogin = () => {
    setShowSignup(false);
    if (onLogin) {
      onLogin();
    }
  };

  const handleBackToLanding = () => {
    setShowSignup(false);
    setShowPrivacy(false);
    setShowTerms(false);
    setShowCookiePolicy(false);
    setShowContact(false);
  };

  const handleNavigate = (page) => {
    if (page === 'home') {
      // Reset all modal states
      setShowSignup(false);
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowContact(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (page === 'features') {
      setShowSignup(false);
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowContact(false);
      document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
    } else if (page === 'how-it-works') {
      setShowSignup(false);
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowContact(false);
      document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
    } else if (page === 'pricing') {
      setShowSignup(false);
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowContact(false);
      document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
    } else if (page === 'blog') {
      if (onBlogClick) onBlogClick();
    } else if (page === 'privacy') {
      setShowSignup(false);
      setShowPrivacy(true);
      setShowCookiePolicy(false);
      setShowTerms(false);
      setShowContact(false);
    } else if (page === 'terms') {
      setShowSignup(false);
      setShowPrivacy(false);
      setShowCookiePolicy(false);
      setShowTerms(true);
      setShowContact(false);
    } else if (page === 'cookies') {
      setShowSignup(false);
      setShowPrivacy(false);
      setShowCookiePolicy(true);
      setShowTerms(false);
      setShowContact(false);
    } else if (page === 'contact') {
      setShowSignup(false);
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowContact(true);
    }
  };

  // Handler functions for legal pages
  const handleLegalLogin = () => {
    // Close legal pages and trigger login from parent
    setShowPrivacy(false);
    setShowTerms(false);
    setShowCookiePolicy(false);
    setShowContact(false);
    if (onLogin) {
      onLogin();
    }
  };

  const handleLegalSignup = () => {
    // Close legal pages and show signup form
    setShowPrivacy(false);
    setShowTerms(false);
    setShowCookiePolicy(false);
    setShowContact(false);
    setShowSignup(true);
  };

  const handleLegalNavigate = (page) => {
    if (page === 'home') {
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowContact(false);
      setShowSignup(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (page === 'features') {
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowSignup(false);
      setShowContact(false);
      document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
    } else if (page === 'how-it-works') {
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowSignup(false);
      setShowContact(false);
      document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
    } else if (page === 'pricing') {
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowContact(false);
      setShowSignup(false);
      document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
    } else if (page === 'blog') {
      if (onBlogClick) onBlogClick();
    } else if (page === 'privacy') {
      setShowPrivacy(true);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowContact(false);
    } else if (page === 'terms') {
      setShowPrivacy(false);
      setShowTerms(true);
      setShowCookiePolicy(false);
      setShowContact(false);
    } else if (page === 'cookies') {
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(true);
      setShowContact(false);
    } else if (page === 'contact') {
      setShowSignup(false);
      setShowPrivacy(false);
      setShowTerms(false);
      setShowCookiePolicy(false);
      setShowContact(true);
    }
  };

  // Render Legal Pages
  if (showPrivacy) {
    return <PrivacyPolicy onNavigate={handleLegalNavigate} onLogin={handleLegalLogin} onSignup={handleLegalSignup} />;
  }

  if (showTerms) {
    return <TermsOfService onNavigate={handleLegalNavigate} onLogin={handleLegalLogin} onSignup={handleLegalSignup} />;
  }

  if (showCookiePolicy) {
    return <CookiePolicy onNavigate={handleLegalNavigate} onLogin={handleLegalLogin} onSignup={handleLegalSignup} />;
  }

  if (showContact) {
    return <ContactUs onNavigate={handleLegalNavigate} onLogin={handleLegalLogin} onSignup={handleLegalSignup} />;
  }

  if (showSignup) {
    return (
      <SignupForm
        onSwitchToLogin={handleSwitchToLogin}
        onBack={handleBackToLanding}
      />
    );
  }

  return (
    <div className="landing-page">
      <CommonHeader
        activePage="home"
        onNavigate={handleNavigate}
        onLogin={onLogin}
        onSignup={() => setShowSignup(true)}
        onBlogClick={onBlogClick}
      />

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Create Dynamic Forms <span className="gradient-text">Effortlessly</span></h1>
            <p>Build custom forms with variety of fields, Fill the values in the corresponding fields, and generate professional PDFs instantly. Perfect for businesses, surveys, and data collection.</p>
            <div className="hero-buttons">
              <button onClick={onGetStarted} className="btn-primary">Get Started Free</button>
              <button onClick={onLogin} className="btn-secondary">View Demo</button>
            </div>
            <div className="stats">
              <div className="stat">
                <span className="stat-number">10K+</span>
                <span className="stat-label">Forms Created</span>
              </div>
              <div className="stat">
                <span className="stat-number">50K+</span>
                <span className="stat-label">Responses</span>
              </div>
              <div className="stat">
                <span className="stat-number">99.9%</span>
                <span className="stat-label">Uptime</span>
              </div>
            </div>
          </div>
          <div className="hero-image">
            <div className="image-placeholder">
              <span>📄 Form Preview</span>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <h2>Powerful Features</h2>
          <p className="section-subtitle">Everything you need to create and manage forms</p>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎨</div>
              <h3>Drag & Drop Builder</h3>
              <p>Create forms visually with our intuitive drag-and-drop interface. No coding required.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Multiple Field Types</h3>
              <p>Text, email, number, date, radio, checkbox, dropdown, and image upload fields.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📄</div>
              <h3>PDF Generation</h3>
              <p>Generate professional PDF documents from form responses with one click.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🖼️</div>
              <h3>Image Upload</h3>
              <p>Upload and store images securely in the cloud with AWS S3 integration.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔐</div>
              <h3>Secure & Private</h3>
              <p>Your data is encrypted and stored securely with enterprise-grade security.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🚀</div>
              <h3>Instant Download</h3>
              <p>Download PDFs immediately after form submission for quick access.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="how-it-works">
        <div className="container">
          <h2>How It Works</h2>
          <p className="section-subtitle">Three simple steps to get started</p>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-icon">✏️</div>
              <h3>Create Template</h3>
              <p>Design your form template with custom sections and fields</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-icon">📝</div>
              <h3>Fill Form</h3>
              <p>Now you have the template, fill the values in the corresponding fields</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-icon">📄</div>
              <h3>Download PDF</h3>
              <p>Generate and download professional PDFs instantly</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="pricing">
        <div className="container">
          <h2>Simple, Transparent Pricing</h2>
          <p className="section-subtitle">Choose the plan that works best for you</p>
          <div className="pricing-grid">
            {/* Free Plan */}
            <div className="pricing-card free-plan">
              <div className="pricing-badge">Most Popular</div>
              <div className="pricing-header">
                <div className="plan-icon">🎯</div>
                <h3>Free Plan</h3>
                <div className="price">
                  <span className="currency">$</span>
                  <span className="amount">0</span>
                  <span className="period">/forever</span>
                </div>
                <p className="plan-description">Perfect for getting started</p>
              </div>
              <div className="pricing-features">
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>Up to <strong>2 templates</strong></span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>Generate up to <strong>5 PDF reports</strong></span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>All form fields including image upload</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>Email support</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>7-day response history</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>Image upload</span>
                </div>
                <div className="feature-item disabled">
                  <span className="feature-cross">✗</span>
                  <span>Priority support</span>
                </div>
              </div>
              <button onClick={onLogin} className="pricing-btn btn-free">Get Started Free</button>
            </div>

            {/* Usage Plan */}
            <div className="pricing-card usage-plan">
              <div className="pricing-badge">Best Value</div>
              <div className="pricing-header">
                <div className="plan-icon">🚀</div>
                <h3>Usage Plan</h3>
                <div className="price">
                  <span className="currency">$</span>
                  <span className="amount">{costPerPdf}</span>
                  <span className="period">/PDF report</span>
                </div>
                <p className="plan-description">Pay as you grow</p>
              </div>
              <div className="pricing-features">
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span><strong>Unlimited templates</strong></span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span><strong>${costPerPdf} per PDF report</strong> generation</span>
                </div>
                <div className="feature-item highlight">
                  <span className="feature-check">✓</span>
                  <span><strong>Unlimited form responses</strong> (except PDF generation)</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>All form fields including image upload</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>Unlimited response history</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>AWS S3 cloud storage for images</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>Priority email support</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>API access</span>
                </div>
                <div className="feature-item highlight">
                  <span className="feature-check">✓</span>
                  <span><strong>No monthly subscription fee</strong> - pay only for what you use</span>
                </div>
              </div>
              <button onClick={onLogin} className="pricing-btn btn-usage">Start Building</button>
            </div>

            {/* Enterprise Plan */}
            <div className="pricing-card enterprise-plan">
              <div className="pricing-header">
                <div className="plan-icon">🏢</div>
                <h3>Enterprise</h3>
                <div className="price">
                  <span className="amount">Custom</span>
                </div>
                <p className="plan-description">For large organizations</p>
              </div>
              <div className="pricing-features">
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span><strong>Unlimited templates</strong></span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span><strong>Bulk PDF pricing</strong> (as low as ${0.5*costPerPdf}/PDF)</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>Custom branding & white-labeling</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>Dedicated account manager</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>SLA guarantee (99.9% uptime)</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>On-premise deployment option</span>
                </div>
                <div className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>SSO & advanced security</span>
                </div>
              </div>
              <button onClick={() => handleNavigate('contact')} className="pricing-btn btn-enterprise">Contact Sales</button>
            </div>
          </div>

          {/* Pricing Note */}
          <div className="pricing-note">
            <p>💡 All plans include: Secure SSL encryption, GDPR compliance, 24/7 monitoring, and regular backups</p>
            <p className="small-note">*PDF reports count only when generated. Form responses (without PDF) are unlimited in Usage plan.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Join thousands of users creating amazing forms with {config.APP_NAME}</p>
          <button onClick={onGetStarted} className="btn-cta">Start Building Forms →</button>
        </div>
      </section>

      <CommonFooter onNavigate={handleNavigate} activePage="home" />
    </div>
  );
};

export default LandingPage;